import { render, staticRenderFns } from "./employeesList.vue?vue&type=template&id=495b4d4f&scoped=true"
import script from "./employeesList.vue?vue&type=script&lang=js"
export * from "./employeesList.vue?vue&type=script&lang=js"
import style0 from "./employeesList.vue?vue&type=style&index=0&id=495b4d4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b4d4f",
  null
  
)

export default component.exports